<div class="icon-container">
    <mat-icon class="icon" *ngIf="isSelected">keyboard_arrow_right</mat-icon>
</div>